(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/helpers/activation-handler.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/helpers/activation-handler.js');
'use strict';

const {
  getRequestsAsync,
  putActivateMemberAsync,
  deleteRequestAsync
} = svs.arena.service.teamsService;
const {
  changeMemberActivity
} = svs.arena.store.teams.actions;
const {
  showActivationDialog,
  showTechnicalError
} = svs.arena.pages.teams.dialogs;
const activationHandler = async dispatch => {
  const {
    data,
    error
  } = await getRequestsAsync();
  if (error) {
    svs.arena.logger.warn('Could not get requests', error);
  } else {
    data.customerRequests.forEach(async request => {
      const teamId = request.referenceId;
      const customerId = request.issuedById;
      const syndicateName = request.syndicateName;
      const memberName = request.issuedBy;
      const activation = await showActivationDialog(memberName, syndicateName);
      if (activation) {
        const {
          error
        } = await putActivateMemberAsync(customerId, teamId);
        if (error) {
          if (error.code === '22 108') {
            dispatch(changeMemberActivity({
              teamId,
              customerId,
              active: true
            }));
          } else {
            svs.arena.logger.warn('Could not activate member', error);
            showTechnicalError();
          }
        } else {
          dispatch(changeMemberActivity({
            teamId,
            customerId,
            active: true
          }));
        }
      } else {
        const {
          error
        } = await deleteRequestAsync(customerId, teamId);
        if (error) {
          svs.arena.logger.warn('Could not delete request', error);
          showTechnicalError();
        }
      }
    });
  }
};
svs.arena.pages.teams.activationHandler = activationHandler;

 })(window);